import DelayEffect from 'effects/Delay.js';
import Effects from 'effects/Effects.js';

export function getDefaultEffects(sequencerEngine) {
    return [];
}
